import { provideEffects } from '@ngrx/effects';

import { AppSettingsEffects } from './app-settings.effects';

export const provideCategoryAppSettingsStore = () => [provideEffects([AppSettingsEffects])];
